import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ListViewDialogInput extends MatDialogDataBaseInput {
	myList: string[];
	title: string;
	description: string;
	okText: string;
}

export interface DialogData_ListViewDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-list-view-dialog",
	templateUrl: "./list-view-dialog.component.html",
	styleUrls: ["./list-view-dialog.component.scss"],
	standalone: false,
})
export class ListViewDialogComponent extends BasicMaterialDialog<
	ListViewDialogComponent,
	DialogData_ListViewDialogInput,
	DialogData_ListViewDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
